<template>
  <houseHeader />
  <div class="app-container">


    <!-- 轮播图区域 -->
    <div class="carousel-container">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
      </div>
      <div v-if="slides && currentSlide" class="carousel">
        <img :src="currentSlide.houseImageUrl" alt="轮播图" class="carousel-image"
          @click="gotoDetail(currentSlide.houseId)">
        <button class="arrow prev" @click="prevSlide">‹</button>
        <button class="arrow next" @click="nextSlide">›</button>
        <div class="indicators">
          <span v-for="(slide, index) in slides" :key="index" :class="['dot', { active: index === currentIndex }]"
            @click="setSlide(index)"></span>
        </div>
      </div>
    </div>

    <!-- 别墅图纸区域 -->
    <div class="villa-section">
      <div class="section-header">
        <h1>热门别墅户型</h1>
        <h5>我们承诺所有图纸免费</h5>
        <!-- <div class="tabs">
          <button v-for="tab in tabs" :key="tab.id" :class="['tab-btn', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id">
            {{ tab.label }}
          </button>
        </div> -->
      </div>

      <!-- 图纸列表 -->
      <!-- <div class="villa-grid">
        <div v-for="villa in hotProducts" :key="villa.houseId" class="villa-item" @click="gotoDetail(villa.houseId)">
          <div class="villa-image-container">
            <img :src="villa.houseImageUrl" :alt="villa.houseName" class="villa-image" loading="lazy" />
          </div>
          <div class="name-container">
            <div class="villa-name-dot">凯尚设计</div>
            <h2 class="villa-name">{{ villa.houseName }}</h2>
          </div>
        </div>
      </div> -->
      <div class="villa-grid">
        <div v-for="villa in hotProducts" :key="villa.houseId" class="villa-item" @click="gotoDetail(villa.houseId)">
          <div class="villa-image-container">
            <!-- 加载动画 -->
            <div v-if="!imageLoaded[villa.houseId]" class="simple-loader"></div>
            <!-- 图片 -->
            <img v-show="imageLoaded[villa.houseId]" :src="villa.houseImageUrl" :alt="villa.houseName"
              class="villa-image" loading="lazy" @load="onImageLoad(villa.houseId)"
              @error="onImageError(villa.houseId)" />
          </div>
          <div class="name-container">
            <div class="villa-name-dot">凯尚设计</div>
            <h2 class="villa-name">{{ villa.houseName }}</h2>
          </div>
        </div>
      </div>
    </div>


    <houseBottom />

  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';
import houseBottom from '@/views/house/bottom/houseBottom.vue';
import houseHeader from '@/views/house/bottom/houseHeader.vue';

const { proxy } = getCurrentInstance();
const router = useRouter();
const hotProducts = ref([]);
const loading = ref(true);
// 添加一个响应式对象来跟踪图片加载状态
const imageLoaded = ref({});

const onImageLoad = (houseId) => {
  imageLoaded.value[houseId] = true;
};

const onImageError = (houseId) => {
  imageLoaded.value[houseId] = true; // 即使出错也隐藏加载动画
};


// const images = ref([]);
// const currentIndex = ref(0);
// const startX = ref(0);
// const endX = ref(0);
const isAdmin = ref('0');
let intervalId = null;

// 轮播图逻辑
const slides = ref([
  {}
]);
const currentIndex = ref(0);
// 添加控制变量（可根据需要动态控制）
// const showPromoImage = ref(true);
const currentSlide = computed(() => slides.value[currentIndex.value]);

const prevSlide = () => {
  currentIndex.value = currentIndex.value === 0
    ? slides.value.length - 1
    : currentIndex.value - 1;
};

const nextSlide = () => {
  currentIndex.value = currentIndex.value === slides.value.length - 1
    ? 0
    : currentIndex.value + 1;
};

const setSlide = (index) => {
  currentIndex.value = index;
};

const gotoDetail = (id) => {
  router.push({
    name: "HouseDetail",
    params: { houseId: id }
  });
};



const fetchImages = async () => {
  const url = '/home/homePage';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if (response.data.rspHead.returnCode === '00000000') {
      hotProducts.value = response.data.rspBody.hotSellingList;
      slides.value = response.data.rspBody.bannerHouseList;
      console.log(slides.value);
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员');
  } finally {
    loading.value = false; // 无论成功或失败都停止加载
  }
};

const checkRule = async () => {
  const url = '/login/checkRule';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if (response.data.rspHead.returnCode === '00000000') {
      isAdmin.value = response.data.rspBody.isAdmin;
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员');
  }
};

const checkLogin = () => {
  let token = localStorage.getItem("token");
  token = token || null;
  if (!token) {
    router.push("/appLogin");
    return Promise.resolve(false);
  }
  const url = "/login/checkLoginStatus";
  return proxy.$tools
    .request(url, { reqBody: {} })
    .then((response) => {
      const returnCode = response.data.rspHead.reurnCode;
      if (!"000000" === returnCode) {
        router.push("/error");
        return false;
      }
      const status = response.data.rspBody.status;
      if ("0" === status) {
        router.push("/appLogin");
        return false;
      }
      return true;
    })
    .catch((error) => {
      console.error(error);
      return false;
    });
};
const autoPlayTimer = ref(null)
const autoPlayDelay = 3000 // 3秒切换一次
// 启动自动轮播
const startAutoPlay = () => {
  autoPlayTimer.value = setInterval(() => {
    nextSlide()
  }, autoPlayDelay)
}

// 停止自动轮播
const stopAutoPlay = () => {
  if (autoPlayTimer.value) {
    clearInterval(autoPlayTimer.value)
    autoPlayTimer.value = null
  }
}
onMounted(async () => {
  const isLoggedIn = await checkLogin();
  if (isLoggedIn) {
    fetchImages();
    checkRule();
  }
  startAutoPlay()
});

// 组件卸载时清除定时器
onUnmounted(() => {
  stopAutoPlay()
})

onBeforeUnmount(() => {
  clearInterval(intervalId);
});
</script>

<style scoped>
:global(body),
:global(html) {
  margin: 0;
  padding: 0;
}

:root {
  --transition-duration: 0.2s;
}

.app-container {
  width: 100%;
  /* padding: 20px; */
  background-color: #fff;
}


.carousel-container {
  position: relative;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  /* 根据实际需要调整高度 */
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.carousel {
  position: relative;
  overflow: hidden;
}

.carousel-image {
  width: 100%;
  height: auto;
  display: block;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

.indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.dot.active {
  width: 30px;
  border-radius: 6px;
  background: blue;
}


/* 别墅图纸区域 */
.villa-section {
  background: #f5f5f5;
  margin-bottom: 100px;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
}

.tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.tab-btn {
  padding: 8px 20px;
  background: #e0e0e0;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.tab-btn.active {
  background: #1890ff;
  color: white;
}

/* 图纸列表样式 */
.villa-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.villa-item {
  background: #ededed;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.villa-item:hover {
  transform: translateY(-5px);
}

.villa-image-container {
  position: relative;
  width: 100%;
  padding-top: 75%;
  overflow: hidden;
  cursor: pointer;
}

.villa-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.simple-loader {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 100%;
  /* background: #f0f0f0 url('@/assets/loading.gif') center center no-repeat; / */
  /* 或者使用纯CSS动画 */
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.simple-loader::after {
  content: "";
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin1 1s linear infinite;
}

@keyframes spin1 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.name-container {
  width: 100%;
  padding: 8px 10px;
  background: #fff;
  text-align: start;
}

.villa-name-dot {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 4px;
  color: #a1a1a8;
  font-size: 0.75rem;
  cursor: pointer;
}

.villa-name-dot:hover {
  color: #d1d1d8;
}

.villa-name-dot::before {
  display: block;
  content: "";
  border-radius: 50%;
  height: 6px;
  width: 6px;
  margin-right: 5px;
  background: rgba(33, 99, 232, 0.75)
}

.villa-name {
  margin: 0;
  overflow: hidden;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(89, 93, 105);
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.villa-name:hover {
  color: rgb(1, 6, 16);
}


@media (min-width: 769px) {
  .villa-list-container {
    width: calc(100% - 300px);
    padding-left: 150px;
    padding-right: 150px;
  }

  .carousel-image {
    height: 400px;
  }

  .villa-section {
    padding: 40px 5%;
  }


}

@media (max-width: 768px) {
  .villa-section {
    /* padding: 40px 5%; */
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 10px;
    margin-top: -20px;
  }

  .section-header {
    padding-top: 30px;
    margin-bottom: 20px;
  }

  .section-header h1 {
    font-size: 22px;
  }

  .section-header h2 {
    font-size: 12px;
  }

  .values-container {
    margin-left: 0px;
    gap: 4px;
  }

  .value-item {
    /* padding: 5px 10px; */
    font-size: 0.935rem;
  }

  .villa-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .villa-name {
    font-size: 0.7rem;
    padding: 8px 5px;
  }

  .no-data-tip {
    padding: 40px 15px;
  }

  .no-data-tip i {
    font-size: 36px;
  }

  .no-data-tip p {
    font-size: 14px;
  }

  .name-container {
    padding: 0;
    height: 30px;
  }

  .villa-name-dot {
    margin-top: 1px;
    margin-bottom: 2px;
    padding-left: 2px;
    font-size: 0.6rem;
  }


  .villa-name {
    margin-top: -8px;
    margin-bottom: 2px;
  }

  @media (max-width: 480px) {
    .villa-grid {
      gap: 10px;
    }
  }
}
</style>
